export default __webpack_public_path__ + "static/media/hht2_ep13_speaking_01.c2d472fb.png";